// aquí renderizo todas las materias :D
import React from "react";
import { Card, Col, Row } from "antd";
import { Toaster } from "react-hot-toast";
import useExamen from '../../hooks/examen/useExamen';

const Examen = () => {

  const { materias, enviarAmateria } = useExamen();

  return (
    <>

      {/* <p className="lead">Empieza respondiendo el examen de inglés</p> */}

      {/*
        holaaaaaaaaaaaa
        holaaaaaaaaaaaa
        holaaaaaaaaaaaa
        holaaaaaaaaaaaa

        bueno, hola persona del futuro, en el componente Col tengo el atributo data-href y tiene una url de localhost,
        esa cosa sólo sirve para hacer las pruebas

      */}
      {/* <Button type="primary" onClick={ () => setNuevasMaterias( [ ...arregloExamen, 2 ] ) }>agregar otra materia</Button>
      { arregloExamen } */}

      <Row gutter={16}>
        {materias.map((e, i) => (
          <Col xs={24} md={12} lg={8} xl={6} style={{ marginBottom: 16 }} key={i}
            onClick={ () => enviarAmateria( e.pk_materia ) } className='card-examen'>
            <Card title={e.materia} hoverable>
              {e.cantidad} preguntas
            </Card>
          </Col>
        ))}
      </Row>
      <Toaster position="bottom-center"/>

{/*
      <button onClick={ iniciarSesion }>iniciarSesion</button>
      <button onClick={ comprobarSesion }>comprobarSesion</button>
      <button onClick={ cerrarSesion }>cerrarSesion</button> */}

    </>
  );
};

export default Examen;
